export function getStylePropertyValue(name: string): string {
  return window.getComputedStyle(document.documentElement).getPropertyValue(name);
}
